var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contactum-fields contactum-range-slider-wrap" },
    [
      _vm.field.show_value === "yes"
        ? _c("div", { staticClass: "contactum-range-output" }, [
            _vm._v("\n    " + _vm._s(_vm.field.prefix)),
            _c("span", [_vm._v(_vm._s(_vm.currentValue))]),
            _vm._v(_vm._s(_vm.field.suffix) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.currentValue,
            expression: "currentValue"
          }
        ],
        class: _vm.class_names("contactum-range-slider"),
        attrs: {
          type: "range",
          min: _vm.field.min_value || 0,
          max: _vm.field.max_value || 100,
          step: _vm.field.step_value || 1,
          disabled: ""
        },
        domProps: { value: _vm.currentValue },
        on: {
          __r: function($event) {
            _vm.currentValue = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "contactum-range-labels" }, [
        _c("span", [
          _vm._v(
            _vm._s(_vm.field.prefix) +
              _vm._s(_vm.field.min_value || 0) +
              _vm._s(_vm.field.suffix)
          )
        ]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            _vm._s(_vm.field.prefix) +
              _vm._s(_vm.field.max_value || 100) +
              _vm._s(_vm.field.suffix)
          )
        ])
      ]),
      _vm._v(" "),
      _vm.field.help
        ? _c("span", { domProps: { innerHTML: _vm._s(_vm.field.help) } })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }